import React from 'react'

import { useTheme } from 'next-themes'
import ReactDOM from 'react-dom'
import { Toaster } from 'sonner'

const Toast: React.FC = () => {
  const { resolvedTheme } = useTheme()
  const toast = (
    <Toaster
      position="bottom-right"
      theme={resolvedTheme as 'light' | 'dark' | 'system' | undefined}
      toastOptions={{
        classNames: {
          toast: 'bg-white america:bg-white dark:bg-primary-950',
          // need !important to actually get it to work
          error:
            '!bg-red-100 dark:!bg-primary-950 !text-red-800 dark:!text-red-200 dark:!border-red-900 dark:!text-red-200',
          warning:
            '!bg-white dark:!bg-primary-950 !text-yellow-800 dark:!text-yellow-200',
          success:
            '!bg-white dark:!bg-primary-950 !text-green-800 dark:!text-green-200',
        },
        closeButton: true,
      }}
    />
  )
  // renders it above everything else regardless of zIndex
  const portalElement = document.getElementById('portal')
  return portalElement ? ReactDOM.createPortal(toast, portalElement) : toast
}

export default Toast
